/**
 * BMAT Widget Module
 * Module with different quasi-static components
 */
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BMATSpinButtonModule } from '@bmat/spin-button';

import { BMBmatMenuIconComponent } from './bmat-menu-icon/bmat-menu-icon.component';
import { BMGraphQLPaginationComponent } from './grahpql-collection-pagination/grahpql-collection-pagination.component';
import { BMHeaderUserOptionsComponent } from './header-user-options/header-user-options.component';
import { BMUserDetailComponent } from './header-user-options/header-user-profile-detail/header-user-profile-detail.component';
import { BMPoweredByComponent } from './powered-by/powered-by.component';
import { BMUserPortraitComponent } from './user-portrait/user-portrait.component';

@NgModule({
  imports: [BMATSpinButtonModule, CommonModule, ReactiveFormsModule],
  declarations: [
    BMBmatMenuIconComponent,
    BMGraphQLPaginationComponent,
    BMHeaderUserOptionsComponent,
    BMPoweredByComponent,
    BMUserDetailComponent,
    BMUserPortraitComponent,
  ],
  exports: [
    BMBmatMenuIconComponent,
    BMGraphQLPaginationComponent,
    BMHeaderUserOptionsComponent,
    BMPoweredByComponent,
  ],
  providers: [],
})
export class BMATWidgetsModule {
  // tslint:disable-next-line:function-name
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: BMATWidgetsModule,
      providers: [],
    };
  }
}
